export default "__VITE_ASSET__CxOnx_uW__"